import { createGlobalStyle } from 'styled-components'

export const GlobalFont = createGlobalStyle`
  body {
    margin: 0px;
    overflow-x: hidden;
    @font-face {
      font-family:"Proxima Nova";
      src:url(//cdn4.careguide.com/assets/ProximaNova/2D6AAD_4_0-a6be35b25b6c72b3a2aa62582c1c36bd70675791d018faaa1506799f8bcf846d.eot);
      src:url(//cdn4.careguide.com/assets/ProximaNova/2D6AAD_4_0-a6be35b25b6c72b3a2aa62582c1c36bd70675791d018faaa1506799f8bcf846d.eot?#iefix) format("embedded-opentype"),
      url(//cdn4.careguide.com/assets/ProximaNova/2D6AAD_4_0-6d3c734aad7bccf4444aeaf128e2834ed681037971bfdf3a340ee783965ffbf3.woff) format("woff"),
      url(//cdn4.careguide.com/assets/ProximaNova/2D6AAD_4_0-70d40ea06da7ada760d7576aa45fd46406ae9500815948aacdcc43d4d331dfea.ttf) format("truetype");
      font-weight:normal;
      font-style:normal
    }
    @font-face {
      font-family:"Proxima Nova";
      src:url(//cdn4.careguide.com/assets/ProximaNova/2D6AAD_5_0-b2c910b0f88f8a8a5c30e88dcae41daf63e32388644774d43aff9d0a0d477d71.eot);
      src:url(//cdn4.careguide.com/assets/ProximaNova/2D6AAD_5_0-b2c910b0f88f8a8a5c30e88dcae41daf63e32388644774d43aff9d0a0d477d71.eot?#iefix) format("embedded-opentype"),
      url(//cdn4.careguide.com/assets/ProximaNova/2D6AAD_5_0-a9b71ab03d15217aa9dde6edddae676302b0c0994516e8518cc6c19d134ac55b.woff) format("woff"),
      url(//cdn4.careguide.com/assets/ProximaNova/2D6AAD_5_0-0b57950e894ca349799b9143f11252e14d786ee477be03944f17e5375999ac77.ttf) format("truetype");
      font-weight:bold;
      font-style:normal
    }
    font-family: "Proxima Nova", "Helvetica Neue", Helvetica, Arial, sans-serif
  }
`
